import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import EstadoFuncional from './EstadoFuncional';




interface EstadoFuncionalTableProps {
  data: EstadoFuncional[];
  columns: TableColumn<EstadoFuncional>[];
  customStyles: Record<string, any>;
}

const EstadoFuncionalTable: React.FC<EstadoFuncionalTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<EstadoFuncional>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default EstadoFuncionalTable;